// @ts-nocheck
import * as reportingMapActions from '../actions/reportingMap.actions';

const initialStore = {};

const actionsMap = {
  [reportingMapActions.SET_MAP_CENTER]: (store, action) => {
    const { center, id } = action.data;
    return {
      ...store,
      [id]: {
        ...store[id],
        center
      }
    };
  },
  [reportingMapActions.SET_MAP_BOUNDS]: (store, action) => {
    const { bounds, id } = action.data;
    const [[right, top], [left, bottom]] = bounds;
    const maxLeft = left < 180 ? left : 180;
    const maxBottom = bottom < 90 ? bottom : 90;
    const maxRight = right > -180 ? right : -180;
    const maxTop = top > -90 ? top : -90;

    return {
      ...store,
      [id]: {
        ...store[id],
        bounds: [
          [maxRight, maxTop],
          [maxLeft, maxBottom]
        ]
      }
    };
  },
  [reportingMapActions.SET_MAP_FIT]: (store, action) => {
    const { fit, id } = action.data;
    return {
      ...store,
      [id]: {
        ...store[id],
        fit
      }
    };
  },
  [reportingMapActions.SET_MAP_TYPE]: (store, action) => {
    const { id, type } = action.data;
    return {
      ...store,
      [id]: {
        ...store[id],
        type
      }
    };
  },
  [reportingMapActions.SET_MAP_ZOOM]: (store, action) => {
    const { id, zoom } = action.data;
    return {
      ...store,
      [id]: {
        ...store[id],
        zoom
      }
    };
  }
};

export default function reducer(store = initialStore, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(store, action) : store;
}
